export enum TableListCellRenderMethod {
  Avatar = '[ViewType] Avatar',
  Html = '[ViewType] Html',
  Icon = '[ViewType] Icon',
  Text = '[ViewType] Text',
  BadgeWithText = '[ViewType] BadgeWithText',
  Transclude = '[ViewType] Transclude',
}
